import React, { useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from "yup";
import { message, Button } from "antd";
import Loader from '../Loader/Loader';
import { createAdmin } from '../../Web Apis/webApis';


const CreateAdmin = ({ showAddAdmin, setShowAddAdmin, action, setAction, }) => {

    const [open, setOpen] = useState(showAddAdmin)
    const [loading, setLoading] = useState(false)
    const [logo, setLogo] = useState(null)

    const formik = useFormik({
        initialValues: {
            firstName: "",
            lastName: "",
            email: "",
            startSubscription: "",
            endSubscription: "",
            companyName: "",
            address: "",
            person_email: "",
            person_number: "",
            companyLogo: null,
        },
        validationSchema: Yup.object({
            firstName: Yup.string().required("First name is required").max(15, "First name should not be more than 15 characters").min(2, "Fist name should be atleast 2 characters long").trim("First name should not have spaces").matches(/^[a-zA-Z\s]*$/, "First name should not contain special characters or numbers"),
            lastName: Yup.string().required("Last name is required").max(15, "Last name should not be more than 15 characters").min(2, "Fist name should be atleast 2 characters long").trim("Last name should not have spaces").matches(/^[a-zA-Z\s]*$/, "Last name should not contain special characters or numbers"),
            email: Yup.string().email("Please enter a valid email address").required("Email is required").trim().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Please enter a valid email address"
            ),
            companyLogo: Yup.string().required("Company logo is required"),
            // startSubscription: Yup.string().required("Subscription start date is required"),
            // endSubscription: Yup.string().required("Subscription end date is required"),
            companyName: Yup.string().required("Company name is required").max(50, "Company name should not be more than 50 characters").min(3, "Company name should be atleast 3 characters long").trim("Company name should not have spaces"),
            address: Yup.string().required("Address is required").max(200, "Address should not be more than 200 characters").min(10, "Address should be atleast 10 characters long").trim("Address should not have spaces"),
            person_email: Yup.string().email("Please enter a valid email address").required("Contact person email is required").trim().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Please enter a valid email address"
            ),
            person_number: Yup.string().required("Phone number is required").matches(/^\d{6,15}$/, "Phone number must be between 6 and 15 digits"),
        }),
        onSubmit: async (values, { resetForm, setSubmitting }) => {
            try {
                setLoading(true)
                const formData = new FormData();

                // Dynamically append fields to formData only if they have values
                if (values.firstName) formData.append("firstName", values.firstName)
                if (values.lastName) formData.append("lastName", values.lastName)
                if (values.email) formData.append("email", values.email)
                if (values.companyName) formData.append("companyName", values.companyName)
                if (values.address) formData.append("address", values.address)
                // if (values.startSubscription) formData.append("startSubscription", values.startSubscription)
                // if (values.endSubscription) formData.append("endSubscription", values.endSubscription)
                if (values.person_email) formData.append("person_email", values.person_email)
                if (values.person_number) formData.append("person_number", values.person_number)
                if (values.companyLogo)  formData.append("companyLogo", values.companyLogo)


                const response = await createAdmin(formData)
                if (response?.data?.success) {
                    message.success(response?.data?.message)
                    resetForm()
                    setOpen(false)
                    setShowAddAdmin(false)
                    setAction(!action)
                }

            } catch (error) {
                console.log("Error while creating admin", error.message)
                message.error(error?.response?.data?.message || "Error while creating admin profile")
            } finally {
                setSubmitting(false)
                setLoading(false)
            }
        }
    })


    const handleCloseModal = () => {
        setOpen(false);
        setShowAddAdmin(false)
    }

    const handleProfileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setLogo(URL.createObjectURL(file));
          formik.setFieldValue("companyLogo", file);
        }
      };

      const handleRemoveImage = () => {
        setLogo(null);
        formik.setFieldValue("companyLogo", null);
      };


    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white  rounded-2xl shadow-lg w-[900px] h-[600px] overflow-y-auto">

                <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-blue-950 to-blue-500 py-2 text-white">
                    Create Admin
                </h3>
                <form onSubmit={formik.handleSubmit} className='p-8'>
                    <h1 className="bg-gray-400 border border-gray-900 flex justify-center text-xl font-semibold mb-2 py-1">
                        Company Details
                    </h1>

                    <div className="flex gap-2 ">
                        <div className="w-full">
                            <label className="block mb-1 mt-2">Company Name :</label>
                            <input
                                type="text"
                                name="companyName"
                                className="border border-gray-800 p-2 w-full"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.companyName}
                                placeholder='Enter your company name'
                            />
                            {formik.touched.companyName && formik.errors.companyName && (
                                <p className="text-red-600">{formik.errors.companyName}</p>
                            )}
                        </div>

                        <div className="w-full">
                            <label className="block mb-1 mt-2">Company Logo:</label>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleProfileChange}
                                className="cursor-pointer"
                            />

                            {formik.touched.companyLogo && formik.errors.companyLogo && (
                                <p className="text-red-600">{formik.errors.companyLogo}</p>
                            )}

                            {logo && (
                                <div className="flex items-center border border-gray-800">
                                    <img
                                        src={logo}
                                        alt="Profile Preview"
                                        className="border border-gray-800 w-16 h-16 object-cover rounded-full mr-2"
                                    />
                                    <Button
                                        type="button"
                                        className="bg-red-600 text-white cursor-pointer"
                                        onClick={handleRemoveImage}
                                    >
                                        Remove Logo
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="w-full">
                        <label className="block mb-1 mt-2">Email :</label>
                        <input
                            type="email"
                            name="email"
                            className="border border-gray-800 p-2 w-full"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                            placeholder="Enter company's email"
                        />
                        {formik.touched.email && formik.errors.email && (
                            <p className="text-red-600">{formik.errors.email}</p>
                        )}
                    </div>



                    {/* <div className="flex gap-2">
                        <div className=' w-full'>
                            <label htmlFor="startDate" className="block mb-1 mt-2">
                                Start Date :
                            </label>
                            <input
                                type="date"
                                name="startSubscription"
                                placeholder="Subscription Start Date"
                                value={formik.values.startSubscription}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                required
                                // min={new Date().toISOString().split("T")[0]}

                                className={`block w-full p-3 border border-gray-800 rounded-md`}
                            />
                            {formik.touched.startSubscription && formik.errors.startSubscription ? (
                                <p className="text-red-600">{formik.errors.startSubscription}</p>
                            ) : null}
                        </div>

                        
                        <div className=' w-full'>
                            <label htmlFor="startDate" className="block mb-1 mt-2">
                                End Date :
                            </label>
                            <input
                                type="date"
                                name="endSubscription"
                                placeholder="Subscription End Date"
                                value={formik.values.endSubscription}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                required
                                // min={new Date().toISOString().split("T")[0]}

                                className={`block w-full p-3 border border-gray-800 rounded-md`}
                            />
                            {formik.touched.endSubscription && formik.errors.endSubscription ? (
                                <p className="text-red-600">{formik.errors.endSubscription}</p>
                            ) : null}
                        </div>
                    </div> */}

                    <div className="w-full col-span-3 mt-2">
                        <label className="block mb-1">Address :</label>
                        <textarea
                            rows={3}
                            name="address"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.address}
                            placeholder="Enter your address"
                            className="border border-gray-800 p-2 w-full"
                        />
                        {formik.touched.address && formik.errors.address && (
                            <p className="text-red-600">{formik.errors.address}</p>
                        )}
                    </div>



                    <h1 className="bg-gray-400 border border-gray-900 flex justify-center text-xl font-semibold mt-2 mb-2 py-1">
                        Contact Person Details
                    </h1>

                    <div className="flex gap-2">
                        <div className="w-full">
                            <label className="block mb-1">First Name :</label>
                            <input
                                type='text'
                                name='firstName'
                                className='border border-gray-900 p-2 w-full'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.firstName}
                                placeholder='Enter your first name'
                            />
                            {formik.touched.firstName && formik.errors.firstName && (
                                <p className='text-red-600'>{formik.errors.firstName}</p>
                            )}
                        </div>

                        <div className="w-full">
                            <label className="block mb-1">Last Name :</label>
                            <input
                                type='text'
                                name='lastName'
                                className='border border-gray-900 p-2 w-full'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.lastName}
                                placeholder='Enter your last name'
                            />
                            {formik.touched.lastName && formik.errors.lastName && (
                                <p className='text-red-600'>{formik.errors.lastName}</p>
                            )}
                        </div>
                    </div>

                    <div className="flex gap-2 mt-2">
                        <div className="w-full">
                            <label className="block mb-1">Contact Person Email :</label>
                            <input
                                type='text'
                                name='person_email'
                                className='border border-gray-900 p-2 w-full'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.person_email}
                                placeholder='Enter contact person email'
                            />
                            {formik.touched.person_email && formik.errors.person_email && (
                                <p className='text-red-600'>{formik.errors.person_email}</p>
                            )}
                        </div>

                        <div className="w-full">
                            <label className="block mb-1">Contact Number :</label>
                            <input
                                type='rel'
                                name='person_number'
                                className='border border-gray-900 p-2 w-full'
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.person_number}
                                placeholder='Enter contact person number'
                            />
                            {formik.touched.person_number && formik.errors.person_number && (
                                <p className='text-red-600'>{formik.errors.person_number}</p>
                            )}
                        </div>
                    </div>




                    <div className="flex justify-center gap-6 mt-6">
                        <button
                            onClick={handleCloseModal}
                            className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2"
                        >
                            Create
                        </button>
                    </div>

                </form>
                {loading && <Loader />}
            </div>
        </div>
    )
}

export default CreateAdmin